<xemex-dialog-shell
  [title]="
    (data.otherInstallations === null
      ? 'installations.attributes.sharedConfirm.titleUnknown'
      : 'installations.attributes.sharedConfirm.title'
    ) | translate: { ldn: data.ldn }
  "
>
  <xemex-alert-banner variant="warning">
    {{
      (data.otherInstallations === null
        ? 'installations.attributes.sharedDevice.unknown'
        : data.otherInstallations === 1
          ? 'installations.attributes.sharedDevice.one'
          : 'installations.attributes.sharedDevice.many'
      ) | translate: { count: data.otherInstallations }
    }}
  </xemex-alert-banner>

  <div actions class="flex w-full items-center justify-end gap-3">
    <xemex-text-button (click)="cancel()">
      {{ 'general.btnCancel' | translate }}
    </xemex-text-button>
    <xemex-filled-button (click)="confirm()">
      {{ 'installations.attributes.sharedConfirm.confirm' | translate }}
    </xemex-filled-button>
  </div>
</xemex-dialog-shell>
